<template>
    <v-dialog
      v-model="dialog"
      max-width="800"
      persistent
    >
      <v-card >
        <v-card-title class="docgo white--text title">
          <v-icon class="pr-4" color="white">
            mdi-briefcase-account-outline
          </v-icon>
          <span>
            {{dialogTitle}}
          </span>
        </v-card-title>
  
          <v-form ref="noticeForm" class="pa-4" v-model="noticeForm" lazy-validation>
            <v-layout column>
              <v-flex>
                <span class="subheading font-weight-bold grey--text text--darken-1">Informações</span>
                
                <v-subheader class="pa-0 custom-margin">
                  Título
                  <span class="red--text">&nbsp;*</span>
                </v-subheader>
                <v-text-field
                  placeholder="Digite aqui o título do aviso"
                  persistent-hint
                  v-model="notice.title"
                  :rules="[validationRules.required]"
                />
              </v-flex>

              <v-flex>
                <v-subheader class="pa-0">
                  Mensagem do aviso
                  <span class="red--text">&nbsp;*</span>
                </v-subheader>
                <v-textarea
                  placeholder="Digite aqui o conteúdo do aviso"
                  counter="3000"
                  maxlength="3000"
                  solo
                  no-resize
                  persistent-hint
                  v-model="notice.body"
                  :rules="[validationRules.required]"
                />
              </v-flex>

              <v-flex>
                <v-subheader class="pa-0 custom-margin">
                  Deseja que o aviso seja mostrado para os usuários?
                </v-subheader>
                <v-checkbox
                  label="Ativo"
                  v-model="notice.active"
                />
              </v-flex>
            </v-layout>
          </v-form>
        <v-card-actions class="px-4 pb-4">
          <v-btn
            flat
            :loading="isSaving"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            @click="saveUpdateNotice()"
            :loading="isSaving"
            :disabled="!noticeForm"
          >
            <v-icon class="pr-2">
              mdi-content-save
            </v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
    import validationRules from '@/mixins/validation-rules';
    import NoticeService from '@/services/system/NoticeService';
  
    export default {
      name: "notice-form",
      props: ['dialog'],
      data() {
        return {
          notice: {},
          noticeForm: true,
          isSaving: false,
          validationRules,
        };
      },
      computed: {
        selectedNotice() {
          return this.$store.getters.notice;
        },
        dialogTitle() {
          return (this.notice && this.notice.id) ? 'Editar Aviso' : 'Novo Aviso';
        },
      },
      methods: {
        closeDialog() {
          this.$emit('update:dialog', false);
          this.resetForms();
        },
        resetForms() {
          this.$refs.noticeForm.resetValidation();
        },
        validateForms() {
          this.$refs.noticeForm.validate();
        },
        saveUpdateNotice() {
          this.validateForms();
          if (this.$refs.noticeForm.validate()) {
            const formData = new FormData();
            formData.append('title', this.notice.title);
            formData.append('body', this.notice.body);
            formData.append('active', this.notice.active);

            this.isSaving = true;
            if (this.notice.id) {
              NoticeService.update(formData, this.notice.id)
                .then(() => {
                  this.$store.dispatch('toggleSnackbar', {
                    show: true,
                    timeout: 6000,
                    color: 'success',
                    message: 'Aviso atualizado com sucesso!',
                    messageIcon: 'mdi-check',
                  });
                  this.closeDialog();
                  this.$emit('updateList');
                }).catch((request) => {
                  this.$store.dispatch('toggleSnackbar', {
                    show: true,
                    timeout: 6000,
                    color: 'error',
                    message: request.response.data.toString(),
                    messageIcon: 'mdi-check',
                  });
                }).finally(() => {
                  this.isSaving = false;
                });
            } else {
              if (formData.get('active') == 'undefined') {
                formData.set('active', 'false');
              }
              NoticeService.create(formData)
                .then(({ data }) => {
                  this.$store.dispatch('toggleSnackbar', {
                    show: true,
                    timeout: 6000,
                    color: 'success',
                    message: 'Aviso criado com sucesso!',
                    messageIcon: 'mdi-check',
                  });
                  this.closeDialog();
                  this.$emit('updateList');
                }).catch((request) => {
                  this.$store.dispatch('toggleSnackbar', {
                    show: true,
                    timeout: 6000,
                    color: 'error',
                    message: request.response.data.toString(),
                    messageIcon: 'mdi-check',
                  });
                }).finally(() => {
                  this.isSaving = false;
                });
            }
          }
        },
      },
      watch: {
        selectedNotice: {
          handler: function(val) {
              this.notice = Object.assign({}, val);
              if(this.notice.id)
                this.validateForms();
              else
                this.resetForms();
          },
        },
      },
    };
  </script>

<style scoped lang="scss">
.text-field-break-word {
  .v-text-field__slot input {
    word-break: break-word;
  }
}

.custom-margin {
  margin-bottom: -18px;
}
</style>



// WEBPACK FOOTER //
// src/components/notice/NoticeForm.vue